<script lang="ts">
  import type { Snippet } from "svelte";
  import type { HTMLAnchorAttributes, HTMLButtonAttributes } from "svelte/elements";
  import Icon from "./Icon.svelte";
  import { CONTROL_OUTLINE, CONTROL_SQUARE, FOCUS_RING, PRESS, TAP_AREA } from "./recipes.ts";

  let {
    label,
    variant = "ghost",
    size = "md",
    tone = "default",
    active = false,
    done = false,
    href,
    disabled = false,
    children,
    ...rest
  }: {
    label: string;
    variant?: "ghost" | "outline";
    size?: "sm" | "md";
    tone?: "default" | "danger";
    active?: boolean;
    done?: boolean;
    href?: string;
    disabled?: boolean;
    children: Snippet;
  } & HTMLButtonAttributes &
    HTMLAnchorAttributes = $props();

  const paint = $derived(
    active
      ? variant === "outline"
        ? "border border-edge-strong bg-surface-2 text-accent-text"
        : "bg-surface-2 text-accent-text"
      : variant === "outline"
        ? `${CONTROL_OUTLINE} text-ink-2 hover:text-ink-1`
        : tone === "danger"
          ? "text-ink-2 hover:bg-surface-2 hover:text-status-serious"
          : "text-ink-2 hover:bg-surface-2 hover:text-ink-1",
  );

  const classes = $derived([
    `grid shrink-0 place-items-center rounded-control select-none ${PRESS} ${FOCUS_RING}`,
    size === "sm" ? ["size-6", TAP_AREA] : CONTROL_SQUARE,
    paint,
    "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
  ]);
</script>

{#snippet glyph()}
  {#if done}
    <Icon name="checked" size={14} />
  {:else}
    {@render children()}
  {/if}
{/snippet}

{#if href !== undefined}
  <a {href} aria-label={label} title={label} {...rest} class={classes}>
    {@render glyph()}
  </a>
{:else}
  <button type="button" aria-label={label} title={label} {disabled} {...rest} class={classes}>
    {@render glyph()}
  </button>
{/if}
